// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3YTWN","closeBackground":"styles_closeBackground__2R93I","wraper":"styles_wraper__1qhsS"};